/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () { // <-- Function starts here
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) { // <-- 'if (refParam)' block starts here
        // Set the "ref" cookie with the "ref" parameter value
        // This line was crucial and was missing in your last attempt.
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a');
        const storeDomain = window.location.hostname; // Get your current store's domain
        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            try {
                const url = new URL(link.href);
                // ONLY modify links that are on your store's domain
                // and avoid internal Shopify paths like /checkouts/internal/
                if (url.hostname === storeDomain && !url.pathname.includes('/checkouts/internal/')) {
                    if (url.search) {
                        url.search += `&ref=${refParam}`;
                    } else {
                        url.search = `?ref=${refParam}`;
                    }
                    link.href = url.href;
                }
            } catch (e) {
                // Log the error for debugging, but don't let it stop the script
                console.error("Error creating URL for link:", link.href, e);
            }
        }
    } // <-- 'if (refParam)' block ends here
} // <-- 'addRefParamToUrlsAndSetCookie' function ends here

// addRefParamToUrlsAndSetCookie() // <-- This line calls the function

document.addEventListener('DOMContentLoaded', function() {
  const priceSpan = document.querySelector('.product-price-final');

  if (priceSpan) {
    const priceText = priceSpan.textContent.trim();
    const currencyIndex = priceText.lastIndexOf(' AUD');

    if (currencyIndex !== -1) {
      const priceValue = priceText.substring(0, currencyIndex);
      const currency = priceText.substring(currencyIndex);

      priceSpan.innerHTML = `<span class="price-value">${priceValue}</span> <span class="currency">${currency}</span>`;
    }
  }
});
